/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PaymentMethodSummaryDTO } from './PaymentMethodSummaryDTO';

export type OutletTransactionSummaryDTO = {
    breakdown?: Array<PaymentMethodSummaryDTO>;
    endDate?: string;
    outletId?: string;
    outletName?: string;
    period?: OutletTransactionSummaryDTO.period;
    startDate?: string;
    totalCount?: number;
    totalVolume?: number;
};

export namespace OutletTransactionSummaryDTO {

    export enum period {
        TODAY = 'TODAY',
        CURRENT_WEEK = 'CURRENT_WEEK',
        CURRENT_MONTH = 'CURRENT_MONTH',
        CURRENT_YEAR = 'CURRENT_YEAR',
        CUSTOM = 'CUSTOM',
    }


}

